import ValidationException from './ValidationException'

export default class InvalidSizeException extends ValidationException {
    constructor (file) {
      super(file)
    }
}
